import styled from 'threads5/styles/styled';

const PlaidLogoWaffle = (props) => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='Plaid'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25.7629 25.7628L28 17.0309L24.9691 14.0001L27.9999 10.9691L25.7628 2.23706L17.0309 0L14.0001 3.031L10.969 0.000140011L2.23706 2.23734L0 10.9691L3.03128 13.9999L0.00014 17.031L2.2372 25.7629L10.9691 28L14.0001 24.969L17.031 27.9999L25.7629 25.7628ZM15.7321 23.2371L18.6186 20.3505L22.2912 24.0233L17.6956 25.2007L15.7321 23.2371ZM11.1136 9.38154L14.0003 6.49502L16.8868 9.3814L14.0001 12.2679L11.1136 9.38154ZM12.2682 14L9.38154 16.8865L6.49502 14L9.38154 11.1135L12.2682 14ZM18.6187 11.1133L21.5053 14L18.6186 16.8865L15.7321 14L18.6187 11.1133ZM16.8867 18.6186L14.0001 21.5051L11.1135 18.6185L14.0001 15.7319L16.8867 18.6186ZM10.3044 25.2007L5.70864 24.0233L9.38154 20.3504L12.2682 23.2371L10.3044 25.2007ZM4.76308 15.7319L7.6496 18.6185L3.9767 22.2914L2.7993 17.6957L4.76308 15.7319ZM3.9767 5.70836L7.64974 9.3814L4.76308 12.2681L2.7993 10.3041L3.9767 5.70836ZM12.2683 4.76294L9.38168 7.6496L5.70892 3.9767L10.3047 2.7993L12.2683 4.76294ZM17.6959 2.7993L22.2915 3.9767L18.6186 7.64946L15.7321 4.76294L17.6959 2.7993ZM23.2372 12.2681L20.3505 9.3814L24.0233 5.70878L25.2007 10.3046L23.2372 12.2681ZM24.0233 22.2914L20.3505 18.6186L23.2372 15.7321L25.2007 17.6957L24.0233 22.2914Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default styled(PlaidLogoWaffle)({});
